import React from "react";
import Header from "./../../Global/Header/Header";
import Footer from "./../../Global/Footer/Footer";

const TripDiary = () => {

  return (
    <>
      <div className="relative">
        <img
          className="w-full h-112 lg:h-full object-cover"
          src="https://static.wixstatic.com/media/dd0cc5_0f244ebc3e77484bbcbe7886ec17f5e2~mv2.webp"
          alt=""
        />
        <div className="absolute top-0 left-0 right-0">
          <Header activeTab={""} />
        </div>

        <div className="w-full absolute top-0 mt-28 lg:mt-36 left-0 right-0">
          <img
            className={"aspect-auto mx-auto block lg:h-40 h-20"}
            src="https://static.wixstatic.com/media/dd0cc5_17649270bb7741f0870e6bd38d85ccca~mv2.png/v1/fill/w_354,h_150,al_c,lg_1,q_85,enc_auto/Screenshot%20from%202023-10-16%2023-45-32.png"
            alt=""
          />
          <div className="flex flex-row mx-auto justify-center mt-8">
            <p
              className={
                "font-Aeonik text-2xl lg:text-7xl text-orange-600 font-bold"
              }
            >
              Trip
            </p>
            <p
              className={
                "font-Aeonik text-2xl lg:text-7xl lg:ms-5 ms-2 text-black font-bold"
              }
            >
              Diary !!
            </p>
          </div>
          <div className="mx-auto text-center">
            <p
              className={
                "lg:text-4xl text-lg mt-8 lg:mt-10 text-orange-600"
              }
            >
              Coming Soon
            </p>
            <p className={"lg:text-4xl text-lg mt-2 lg:mt-4 text-black"}>
              We are preparing your personalised Tripdiary
            </p>
            <p className={"lg:text-3xl text-lg mt-2 lg:mt-4 text-black"}>
              Stay Tuned ...
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default TripDiary;
